import {useState} from "react";
import {Check, Copy, ExternalLink, Link2} from "lucide-react";
import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";
import {adminToast} from "@/lib/adminToast";

type Props = {
  url: string;
  label?: string;
  className?: string;
};

/** Invite / share link row with copy + open — presentation only. */
export function AdminInviteLink({url, label = "Invite link", className}: Props) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      adminToast.success("Copied!");
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      adminToast.error("Could not copy link");
    }
  }

  return (
    <div className={cn("admin-invite-link", className)}>
      <div className="admin-invite-link__icon" aria-hidden>
        <Link2 className="h-4 w-4" />
      </div>
      <div className="admin-invite-link__body min-w-0">
        <p className="admin-invite-link__label">{label}</p>
        <a className="admin-invite-link__url" href={url} target="_blank" rel="noreferrer">
          {url}
        </a>
      </div>
      <div className="admin-invite-link__actions">
        <Button type="button" size="sm" variant="outline" onClick={copy}>
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? "Copied!" : "Copy"}
        </Button>
        <Button type="button" size="sm" variant="secondary" asChild>
          <a href={url} target="_blank" rel="noreferrer">
            <ExternalLink className="h-4 w-4" />
            Open
          </a>
        </Button>
      </div>
    </div>
  );
}
